import React, { useState, useEffect, useRef } from 'react';
import { Box, Button } from '@material-ui/core';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'dva';
import { history, useLocation } from 'umi';
import Alert from '@material-ui/core/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';
import ErrorIcon from '@material-ui/icons/Error';
import BasicSetting from '../components/BasicML';
import TitleML from './components/TitleML';
import LabelRules from './components/label_rules';
import CreateLabelStyled from './CreateLabelStyled';
import DoneIcon from '@material-ui/icons/Done';
import DeleteIcon from '@material-ui/icons/Delete';
import DialogDataML from '@/components/DialogDataML/DialogDataML';
import webStorage from '@/utils/storageManager';
import Loading from '@/components/LoadingML/LoadingML';

const creatId = () => {
  return Math.random().toString(36).substr(2, 10);
};

// 每条新增原始数据
const creatObj = () => {
  return {
    id: creatId(),
    operation: null, // 标签规则运算符, > < =
    operationAnd: null, // 标签运算符，'计算类型为，相对的时候所用' 过去、将来、至过去等
    operationAndValue: null, // 标签运算符，'计算类型为，相对的时候所用' 过去、将来、至过去等对应的值
    operationType: null, // 标签运算类型 1-有值 2-无值 3-绝对 4-相对
    operationValue: null, // 标签运算需要的数值 > < = 对应的值
    profileTagId: null, // 标签物理ID
    valueFieldIds: null, // 标签规则所选字段ID
    valueType: null, // 类型 1-文本输入 2-下拉框 3-日期类型 4-日期时间类型
    sqlText: null,
    url: null,
  };
};

const CreateLabel = () => {
  const location = useLocation();
  const { query } = location;
  const queryType = query?.opt; //编辑 详情 string
  const tagId = query.tagId ? Number(query.tagId) : null; //标签id int
  const type = query?.type; //标签类型  string
  const chooseLabel = query?.chooseLabel; //入口类型  string
  const dispatch = useDispatch();
  const submitRef = useRef();
  const [ruleBehaviorData, setRuleBehaviorData] = useState();
  const [tagRule, setTagRule] = useState([creatObj()]);
  //创建防抖
  const [disabledConfirm, setDisabledConfirm] = useState(true);
  const [saveOpen, setSaveOpen] = useState({
    tips: '',
    status: false,
    title: '',
  });
  //外部导入文件list
  const [fileList, setFileList] = useState([]);
  // 用户菜单权限
  const userAuths = webStorage.get('USER')?.authorities;
  const [alertOpen, setAlertOpen] = useState(false);
  const {
    handleSubmit,
    control,
    errors,
    getValues,
    setValue,
    clearErrors,
    setError,
    // formState: { isSubmitted },
  } = useForm();
  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['createLabel/queryTagAndRule'];
  const submitLoading =
    loadingEffect.effects['createLabel/insertOrUpdateTagAndRule'];

  //显示确定提示弹窗
  const handleSubmitDialog = () => {
    setSaveOpen({
      status: true,
      tips: '确认保存当前所创建的内容？',
      title: '保存',
    });
  };

  // 退出
  const handleSignOut = () => {
    if (queryType === 'detail') {
      history.goBack();
      return;
    }
    setSaveOpen({
      status: true,
      tips: '退出后将不保存设置内容，确定要退出吗？',
      title: '退出',
    });
  };

  const setFieldValue = (parameter) => {
    const { selfId, value, realName } = parameter;
    tagRule.forEach((item) => {
      if (item.id === selfId) {
        item[realName] = value;
      }
    });
    setTagRule([...tagRule]);
  };
  // 详情数据赋值
  useEffect(() => {
    !tagId && setValue('updateStrategy', '1');
    !tagId && setValue('ruleType', '3');
    !tagId && setValue('status', type === '5' ? '2' : '1');
    !tagId && setValue('importId', '3');
  }, [setValue, tagId, type]);

  // 新增规则数据
  const handleAddRuleDetailData = () => {
    tagRule.push(creatObj());
    setTagRule([...tagRule]);
  };
  // 删除
  const handleAddRuleDetailDataDelete = ({ selfId }) => {
    const tagRuleList = tagRule.filter((item) => item.id !== selfId);
    setTagRule([...tagRuleList]);
  };
  // 标签树
  useEffect(() => {
    dispatch({
      type: 'labelManage/getQueryTagTreeCL',
      payload: {
        values: {},
      },
    });
  }, [setValue, dispatch, type]);

  //详情
  useEffect(() => {
    const fetch = async () => {
      chooseLabel !== 'importlabel' &&
        (await dispatch({
          type: 'createLabel/queryFileList',
          payload: {
            values: {},
          },
        }));
      chooseLabel !== 'importlabel' &&
        (await dispatch({
          type: 'createLabel/queryTagBehaviorList',
          payload: {
            values: {
              type: type,
            },
          },
        }));
      if (tagId) {
        await dispatch({
          type: 'createLabel/queryTagAndRule',
          payload: {
            values: {
              tagId,
            },
          },
          callback: async (data) => {
            const newData = JSON.parse(JSON.stringify(data));
            const updateStrategy = String(newData.updateStrategy);
            setValue('name', newData.name);
            setValue('pid', newData.pid);
            setValue('updateStrategy', updateStrategy);
            setValue('remark', newData.remark);
            setValue('status', String(newData.status));
            setValue('sqlText', newData.sqlText);
            setRuleBehaviorData(newData.ruleBehaviorData);
            setValue('importId', String(newData.importId));
            newData.ruleType && setValue('ruleType', String(newData.ruleType));
            setValue('url', newData.fileUri);
            newData.fileUri &&
              setFileList([
                {
                  url: newData.fileUri,
                  id: newData.id,
                  fileName: data.fileName,
                },
              ]);
          },
        });
      }
    };
    fetch();
  }, [dispatch, setValue, tagId, type]);

  //按钮防抖
  const onSubmitError = () => {
    setDisabledConfirm(true);
    window.message.toast({
      type: 'error',
      message: '输入有误',
    });
  };

  // 创建
  const onSubmitSuccess = (data) => {
    if (!disabledConfirm) {
      return;
    }
    setDisabledConfirm(false);
    const postData = {
      id: tagId ? tagId : null,
      name: data.name,
      nameEn: '',
      pid: data.pid,
      remark: data.remark,
      ruleType: data.ruleType ? Number(data.ruleType) : Number(type),
      source: 1,
      type: Number(type),
      updateStrategy: Number(data.updateStrategy),
      status: data.status,
      tagRule: [],
      ruleBehaviorData: {},
      sqlText: data.sqlText,
      fileUri: fileList?.length ? fileList[0].url : null,
      fileName: fileList?.length ? fileList[0].fileName : null,
      importId: data.importId,
    };
    window.NE_DAWN.trigger(submitRef.current, {
      event: '_ec', // 事件名
      params: { ...postData }, // 事件公参
    });
    dispatch({
      type: 'createLabel/insertOrUpdateTagAndRule',
      payload: {
        values: postData,
      },
      callback: (res) => {
        if (res.code === 0) {
          setAlertOpen(true);
          history.goBack();
        } else {
          window.message.toast({
            type: 'error',
            message: res.message,
            title: res.message,
          });
        }
      },
    });
  };

  //标签导入字段配置
  useEffect(() => {
    dispatch({
      type: 'crowdImport/queryGroupImportConfigList',
      payload: {
        values: {
          importType: 1,
        },
      },
      callback: () => {},
    });
  }, [dispatch, setValue]);

  //新建标签自定义按钮
  const initButton = () => {
    const buttonNode = (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '0 16px',
          width: '100%',
          marginBottom: '24px',
          marginRight: '24px',
        }}
      >
        <Button
          sx={{
            width: '100px!important',
          }}
          variant="contained"
          onClick={onCloseDialog}
          color="secondary"
        >
          取消
        </Button>
        <Button
          sx={{ width: '100px!important' }}
          variant="contained"
          onClick={onSaveLabelDialog}
        >
          确定
        </Button>
      </Box>
    );
    return { buttonNode, isShow: true, height: 'auto' };
  };

  const onSaveLabelDialog = () => {
    setSaveOpen({
      ...saveOpen,
      status: false,
    });
    if (saveOpen.title === '保存') {
      submitRef.current.click();
    } else if (saveOpen.title === '退出') {
      history.goBack();
    } else {
      dispatch({
        type: 'labelManage/deleteLabel',
        payload: {
          values: {
            tagId,
          },
        },
        callback(res) {
          if (res.code === 0) {
            webStorage.set('DELETE_TAG', tagId);
            window.message.toast({
              type: 'success',
              message: '删除成功',
              title: '删除成功',
            });
            setTimeout(() => {
              history.goBack();
            }, 2000);
          }
        },
      });
    }
  };

  const onCloseDialog = () => {
    setSaveOpen({
      ...saveOpen,
      status: false,
    });
  };

  const handleDelete = () => {
    setSaveOpen({
      status: true,
      tips: `确认删除“${getValues('name')}”标签？删除后将无法复原。`,
      title: '删除',
    });
  };

  const handleClose = () => {
    setAlertOpen(false);
  };

  return (
    <CreateLabelStyled>
      <Loading loading={loading || submitLoading}>
        <Box
          data-log={JSON.stringify({
            oid: 'page_user_profile_label_management_edit',
            isPage: true,
            params: {
              initUrl: window.location.origin + window.location.pathname,
            },
            events: ['_pv', '_pd'],
          })}
        >
          <form onSubmit={handleSubmit(onSubmitSuccess, onSubmitError)}>
            <Box borderRadius="12px" bgcolor="background.paper" p={4}>
              <TitleML title="标签基本设置" fontSize="19px" p="0 0 32px 0" />
              <BasicSetting
                queryType={queryType}
                control={control}
                getValues={getValues}
                setValue={setValue}
                errors={errors}
                setError={setError}
                clearErrors={clearErrors}
                chooseLabel={chooseLabel}
              />
            </Box>
            <Box
              borderRadius="12px"
              bgcolor="background.paper"
              p={4}
              mt={0.5}
              mb={0.5}
            >
              <TitleML title="标签规则设置" fontSize="19px" p="0" />
              <LabelRules
                queryType={queryType}
                control={control}
                getValues={getValues}
                setValue={setValue}
                errors={errors}
                tagRule={tagRule} //非集合标签规则数据
                setError={setError}
                clearErrors={clearErrors}
                type={type}
                ruleBehaviorData={ruleBehaviorData}
                handleAddRuleDetailData={handleAddRuleDetailData}
                handleAddRuleDetailDataDelete={handleAddRuleDetailDataDelete}
                setFieldValueP={setFieldValue}
                setFileList={setFileList}
                fileList={fileList}
              />
            </Box>
            <Box
              borderRadius="4px"
              bgcolor="background.paper"
              p={4}
              mt={0.5}
              mb={0.5}
              display="flex"
              alignItems="center"
            >
              {queryType !== 'detail' && (
                <Button
                  variant="contained"
                  // type="submit"
                  onClick={handleSubmitDialog}
                  startIcon={
                    <DoneIcon sx={{ width: '16px', height: '16px' }} />
                  }
                  sx={{ marginRight: '16px' }}
                  // disabled={disabledConfirm}
                >
                  保存
                </Button>
              )}
              {queryType === 'edit' && (
                <Button
                  data-log={JSON.stringify({
                    oid: 'btn_user_profile_label_management_edit_delete',
                    events: ['_ev', '_ec'],
                    params: {
                      tagId,
                    },
                  })}
                  style={{
                    marginRight: '15px',
                    backgroundColor:
                      userAuths.indexOf('OPT_PROFILE_TAG_DELETE') > -1
                        ? '#CA2C21'
                        : '#F5F5F5',
                    color:
                      userAuths.indexOf('OPT_PROFILE_TAG_DELETE') > -1
                        ? '#fff'
                        : '#ccc',
                  }}
                  variant="contained"
                  className="cancel"
                  startIcon={
                    <DeleteIcon sx={{ width: '16px', height: '16px' }} />
                  }
                  onClick={
                    userAuths.indexOf('OPT_PROFILE_TAG_DELETE') > -1 &&
                    handleDelete
                  }
                >
                  删除
                </Button>
              )}
              <Button
                style={{
                  marginRight: '15px',
                  backgroundColor: '#212121',
                  color: '#fff',
                }}
                variant="contained"
                color="secondary"
                className="cancel"
                startIcon={<CloseIcon sx={{ width: '16px', height: '16px' }} />}
                onClick={handleSignOut}
              >
                退出
              </Button>
              <Button
                data-log={JSON.stringify({
                  oid: 'btn_user_profile_label_management_edit_save',
                  events: ['_ev'],
                  params: {
                    initUrl: window.location.origin + window.location.pathname,
                  },
                })}
                sx={{ display: 'none' }}
                type="submit"
                ref={submitRef}
              ></Button>
            </Box>
          </form>
          <DialogDataML
            open={saveOpen.status}
            title={
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <span
                  style={{
                    fontSize: '18px',
                    fontWeight: 600,
                    color: '#212121',
                  }}
                >
                  {saveOpen.title}
                </span>
              </Box>
            }
            content={<Box sx={{ width: '336px' }}>{saveOpen.tips}</Box>}
            handleClose={onCloseDialog}
            button={initButton()}
          />
        </Box>
      </Loading>
      <Snackbar
        open={alertOpen}
        autoHideDuration={2000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'top' }}
      >
        <Alert
          severity="info"
          sx={{
            width: '419px',
            backgroundColor: '#E5F6FD',
            fontSize: '14px',
            lineHeight: '22px',
          }}
          iconMapping={{
            info: <ErrorIcon fontSize="inherit" sx={{ color: '#2094D6' }} />,
          }}
        >
          标签包上传中，可在我的任务查看导出结果
        </Alert>
      </Snackbar>
    </CreateLabelStyled>
  );
};

export default CreateLabel;
